import "./App.scss";
import { Route, Routes, useLocation } from "react-router-dom";
import "swiper/css";
import { Fragment, useEffect } from "react";
import { ParallaxProvider } from "react-scroll-parallax";
import {
  Home,
  About,
  Projects,
  ProjectDetail,
  News,
  NewsDetail,
  Location,
  Amenites,
  Contact,
  ErrorPage,
  Thanks
} from "./pages/index.js";
import { paths } from "./utils/paths.js";
import useExecuteContext from "./utils/hooks/executeContext.js";
function App() {
  const location = useLocation();
  const { setMenuStatus } = useExecuteContext();

  useEffect(() => {
    window.scrollTo(0, 0);
    setMenuStatus(false);
  }, [location.pathname]);

  return (
    <Fragment>
      <ParallaxProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path={paths.ABOUT} element={<About />} />

          <Route path={paths.EVENTS} element={<News />} />

          <Route path={paths.AMENITIES} element={<Amenites />} />
          <Route path={paths.LOCATION} element={<Location />} />
          <Route path="/projects/:type" element={<Projects />} />
          <Route path="/project/:slug" element={<ProjectDetail />} />
          <Route path="/contact" element={<Contact />} />
           <Route path="/thanks" element={<Thanks />} />
          <Route path="/*" element={<ErrorPage />} />
        </Routes>
      </ParallaxProvider>
    </Fragment>
  );
}

export default App;
